import React, { useState } from "react";
import { Button, Col, FormGroup, Input } from "reactstrap";
import api from "../../../../../../../services/api";
import ReactBSAlert from "react-bootstrap-sweetalert";

import { ParcelaProps } from ".";

interface PlanoItemProps {
  plano: ParcelaProps;
  //   reload: () => Promise<void>;
  notify: (type: string, message: string) => void;
  onreload: () => void
  //   removeLocally: (contatoToUpdate: PlanoPagamentoProps) => void;
  //   updateLocally: (contatoToUpdate: PlanoPagamentoProps) => void;
}

export function PlanoItem({
  plano,
  //   reload,
  onreload,
  notify,
  //   removeLocally,
  //   updateLocally,
}: PlanoItemProps) {
  const [nome, setNome] = useState(plano?.nome);
  const [descricao, setDescricao] = useState(plano?.descricao);
  const [quantidade, setQuantidade] = useState(plano?.quantidade);
  const [valor, setValor] = useState(plano?.valor);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState<JSX.Element | null>(null);




  function valid() {
    if (nome.length < 2 || quantidade <= 0 || valor <= 0) {
      notify("danger", "Verifique todos os campos do plano.");
      return false;
    }
    return true;
  }



  async function handleUpdatePlanos() {
    const isValid = valid();
    if (!isValid) return;

    try {
      setIsLoading(true);
      await api.put(`/common/parcelas/${plano.id}`, {
        nome,
        descricao,
        quantidade,
        valor,
      });

      notify("success", "Parcela atualizada com sucesso!");
      setIsEditing(false);
      onreload();

    } catch (error) {
      console.error(error);
      notify("danger", "Erro ao atualizar a parcela.");
    } finally {
      setIsLoading(false);
    }
  }

  async function handleRemovePlanos() {
    try {
      setIsLoading(true);
      await api.delete(`/common/parcelas/${plano.id}`);
      notify("success", "Parcela removida com sucesso!");
      onreload()
    } catch (error) {
      console.error(error);
      notify("danger", "Erro ao remover a parcela.");
    } finally {
      setIsLoading(false);
    }
  }

  function showDeleteConfirm() {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block" }}
        title="Confirmação"
        onConfirm={async () => {
          setAlert(null);
          await handleRemovePlanos();
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="danger"
        confirmBtnText="Sim"
        cancelBtnText="Não"
        showCancel
      >
        Deseja realmente excluir esta parcela?
      </ReactBSAlert>
    );
  }


  function showDeletedMessage() {
    setAlert(

      <ReactBSAlert
        warning
        style={{ display: "block" }}
        title="Confirmação"
        onConfirm={async () => {
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="primary"

        confirmBtnText="Ok"

      >
        Deseja realmente excluir esta parcela?
      </ReactBSAlert>

    )
  }

  return (
    <>
      {alert}
      <div className="w-100 d-flex">
        <Col lg="3" className="p-1">
          <FormGroup>
            <Input
              disabled={!isEditing}
              placeholder="Nome"
              className="form-control"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="p-1">
          <FormGroup>
            <Input
              disabled={!isEditing}
              type="number"
              placeholder="Quantidade"
              className="form-control"
              value={quantidade}
              onChange={(e) => setQuantidade(+e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col lg="2" className="p-1">
          <FormGroup>
            <Input
              disabled={!isEditing}
              type="number"
              placeholder="Valor"
              className="form-control"
              value={valor}
              onChange={(e) => setValor(+e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col className="p-1">
          <FormGroup>
            <Input
              disabled={!isEditing}
              placeholder="Descricao"
              className="form-control"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col className="p-1">
          <FormGroup className="d-flex align-items-center">
            {isEditing && (
              <Button
                type="button"
                outline
                color="primary"
                size="sm"
                onClick={handleUpdatePlanos}
                disabled={isLoading}
              >
                Salvar
              </Button>
            )}
            <Button
              className="btn-sm"
              color="primary"
              onClick={() => setIsEditing(!isEditing)}
            >
              <i
                className={`fas ${isEditing ? "fa-times-circle" : "fa-edit"}`}
              ></i>
            </Button>
            <Button
              className="btn-sm"
              color="danger"
              onClick={showDeleteConfirm}
              disabled={isLoading}
            >
              <i className="fas fa-trash"></i>
            </Button>
          </FormGroup>
        </Col>
      </div>
    </>
  );
}
